export const DISABLE_TELEPHONE = 'DISABLE_TELEPHONE';
export const SHOW_PHONE_OPT_OUT_CHECKBOX = 'SHOW_PHONE_OPT_OUT_CHECKBOX';
